import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAppointment = (clinicId,date="today")=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/dashboard-appointments?date="+date)
}

const dashboardService = {
    getAppointment
}

export default dashboardService